<template>
  <b-row>
    <b-col md="4">
      <b-card
        header-text-variant="white"
        style="height: 100%;"
      >
        <b-img
          center
          src="https://www.shareicon.net/data/128x128/2016/04/10/747365_man_512x512.png"
          rounded="circle"
          alt="Circle image"
          style="margin-top: 55px;"
        ></b-img>
        <br>
        <h5 align="center" class="title">{{user.nombreUsuario}} {{user.apellidoP}}</h5>
      </b-card>
    </b-col>
    <b-col md="8">
      <b-card
        style="height: 100%;"
      >
        <div slot="header">
        <span>
          <strong>Editar Perfil</strong>
        </span>
      </div>
        <b-row>
          <b-col md="6">
            <b-form-group>
              <label for="input-email">Correo Electrónico:</label>
              <b-form-input
               id="input-email"
               name="input-email"
               v-model="newUser.email"
               placeholder="Ingrese su Correo Electrónico"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group>
              <label for="input-name">Nombre(s):</label>
              <b-form-input
                id="input-name"
                name="input-name"
                v-model="newUser.nombreUsuario"
                placeholder="Ingrese su Nombre"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group>
              <label for="input-last">Apellido Paterno:</label>
              <b-form-input
                id="input-last"
                name="input-last"
                v-model="newUser.apellidoP"
                placeholder="Ingrese su Primer Apellido"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group>
              <label for="input-last2">Apellido Materno:</label>
              <b-form-input
                id="input-last2"
                name="input-last2"
                v-model="newUser.apellidoM"
                placeholder="Ingrese su Segundo Apellido"
              ></b-form-input>
            </b-form-group>
          </b-col>
          
          <!--para actualizar contraseña-->
          <b-col md="6">
            <b-form-group>
              <label for="pass-edit">Nueva Contraseña</label>
              <b-form-input
                id="pass-edit"
                name="pass-edit"
                type="password"
                placeholder="Ingrese la Nueva Contraseña"
                data-vv-as="Nueva contraseña"
                autocomplete="new-password"
                v-validate="'min:6'"
                v-model="newUser.password"
                :state="this.validateState('pass-edit')"
                ref="pass-edit"
              />
              <b-form-invalid-feedback :state="this.validateState('pass-edit')">
                <span v-for="error in errors.collect('pass-edit')" :key="error">{{ error }}</span>
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group>
              <label for="pass-edit-con">Confirmar Contraseña:</label>
              <b-form-input
                id="pass-edit-con"
                name="pass-edit-con"
                data-vv-as ="Confirmar contraseña"
                v-validate="'required|confirmed:pass-edit'"
                type="password"
                placeholder="Confirmar Contraseña"
                :state="this.validateState('pass-edit-con')"
                v-model="newUser.confirm"
              />
              <b-form-invalid-feedback :state="this.validateState('pass-edit-con')">
                <span v-for="error in errors.collect('pass-edit-con')" :key="error">{{ error }}</span>
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>
        </b-row>
        
        <b-row>
          <b-col>
            <b-button
             @click="onSubmitUpdate" 
             variant="primary"
             block
             :disabled="errors.any()"
            >
              Actualizar
            </b-button>
          </b-col>
        </b-row>
      </b-card>
    </b-col>
  </b-row>
</template>

<style lang="scss" scoped>
</style>

<script>
import { Callout } from "@coreui/vue";
import { UserService } from "@/services/user.service";

export default {

    name:'perfil',
    data() {
    	return {
    		/*user: {
          nombreUsuario:'',
          apellidoP:'',
          apellidoM:'',
          email:'',
          password:''
        },*/
        newUser:{
          nombreUsuario:'',
          apellidoP:'',
          apellidoM:'',
          email:'',
          password:''
        }
    	}
    },
    created() {
      this.newUser = Object.assign({},this.$store.getters['auth/infoUser']);
      this.user = this.$store.getters['auth/infoUser'];
      console.log(this.newUser);
    },
    components: {
        Callout
    },
    methods: {
    		onSubmitUpdate(){
          this.$swal({
            type: "warning",
            text: "¿Seguro que Desea Actualizar su Información?",
            showConfirmButton: true,
            showCancelButton: true,
            confirmButtonText: "Sí",
            cancelButtonText: "No",
            cancelButtonColor: "#aaa",
            confirmButtonColor: "#285c4d",
          })
          .then(res =>{
            if (res.value == true){
              var dataUpdate = {
                data: this.newUser,
                query: {"_id": this.newUser._id }
              }
              UserService.edit(dataUpdate)
              .then(response => {
                console.log(response),
                this.$swal({
                  type: "success",
                  title: "¡Información Actualizada!",
                  text: "Deberá Iniciar Sesión Para Completar la Actualización",
                  showConfirmButton: true,
                  confirmButtonText: "Aceptar"
                })
                console.log(this.user)
                this.user = this.newUser;
              })

              UserService.refreshToken()
              .then(response => {
                console.log("entro en perfil")
              })
              /*var promise = new Promise (response => {
                console.log('antes de clear');
                response(this.$store.dispatch('auth/refreshToken',this.user.email, this.user.password));
                console.log(customRequest());
                console.log('before login');
                response(this.$store.dispatch('auth/login',this.user.email, this.user.password));
                console.log(response);
              })
              
              /*,
              UserService.refreshToken(this.user.email, this.user.password)
              .then(response => {
                console.log('refresh en perfil'),
                console.log(response)
              })*/
            } else if (error == 500 || error == 400) {
              this.$swal({
                type: "error",
                title: "¡Error!",
                text: "Ha ocurrido un error en la base de datos"
              })
            } 
          });
        },
        validateState(ref){
          if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)){
            return !this.errors.has(ref)
          }
          return null
        }
    }
}
</script>
